import api from './api';

export const shortlistService = {
  getShortlistedCars: async (page = 1) => {
    try {
      const response = await api.get(`/shortlists?page=${page}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching shortlisted cars:', error);
      throw error;
    }
  },

  addToShortlist: async (carId) => {
    try {
      const response = await api.post('/shortlists', { car_id: carId });
      return response.data;
    } catch (error) {
      console.error('Error adding to shortlist:', error);
      throw error;
    }
  },

  removeFromShortlist: async (carId) => {
    try {
      const response = await api.delete(`/shortlists/${carId}`);
      return response.data;
    } catch (error) {
      console.error('Error removing from shortlist:', error);
      throw error;
    }
  },

  // Use this ONLY on the car detail page where you need the live shortlist count.
  // Never call this in a list/loop — use isShortlisted() from ShortlistContext instead.
  getCarShortlistStatus: async (carId) => {
    try {
      const response = await api.get(`/cars/${carId}/shortlist-status`);
      return response.data;
    } catch (error) {
      console.error('Error checking shortlist status:', error);
      return { is_shortlisted: false, shortlist_count: 0 };
    }
  },

  // Bulk fetch — ONE call on app load, never per-car.
  getShortlistedCarIds: async () => {
    try {
      const response = await api.get('/shortlists/car_ids');
      return response.data?.data || [];
    } catch (error) {
      console.error('Error fetching shortlisted car IDs:', error);
      return [];
    }
  },
};